import axios from "axios";

const model = "CAUsers";

export default {
  login(data) {
    return axios.post(`/${model}/login`, data);
  },

  logout(data) {
    return axios.post(`/${model}/logout`, data);
  },

  passwordRecovery(data) {
    return axios.post(`/${model}/passwordRecovery`, data);
  },

  passwordReset(data) {
    return axios.post(`/${model}/passwordReset`, data);
  },

  info(id) {
    return axios.get(`/${model}/${id}/info`);
  },

  listing({ params }) {
    // console.log(params);
    return axios.get(`/${model}`, { params });
  },

  details(id, { params }) {
    return axios.get(`/${model}/${id}`, { params });
  },

  update(id, data) {
    return axios.put(`/${model}/${id}`, data);
  },

  patch(id, data) {
    return axios.patch(`/${model}/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/${model}/${id}`);
  },

  create(data) {
    return axios.post(`/${model}`, data);
  },

  changePassword(id, data) {
    return axios.post(`/${model}/${id}/changePassword`, data);
  },

  confirmationEmail(data) {
    return axios.post(`/${model}/confirmationEmail`, data);
  }
};
